import { render, staticRenderFns } from "./ModelElement.vue?vue&type=template&id=82858d82&scoped=true&"
import script from "./ModelElement.vue?vue&type=script&lang=js&"
export * from "./ModelElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82858d82",
  null
  
)

export default component.exports